// 数据分块
export function splitDataIntoChunks(data, chunkSize) {
  const chunks = [];
  let chunk = [];
  let currentSize = 0;

  for (let i = 0; i < data.length; i++) {
    const eventData = data[i];
    const eventSize = JSON.stringify(eventData).length;

    if (currentSize + eventSize > chunkSize) {
      chunks.push(chunk);
      chunk = [];
      currentSize = 0;
    }

    chunk.push(eventData);
    currentSize += eventSize;
  }

  if (chunk.length > 0) {
    chunks.push(chunk);
  }

  return chunks;
}
